import { render } from "./videos-page.vue?vue&type=template&id=6a13a02a&class=bg-%5B%23fafbfb%5D"
import script from "./videos-page.vue?vue&type=script&lang=js"
export * from "./videos-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__